export default {
  api: {
    error: {
      city: {
        found: "City already exists."
      }
    }
  }
}
